import type CurrencyProviderInterface from "@modules/money/CurrencyProvider/CurrencyProviderInterface";
import {
    currencyProviderToken,
    moneyFormatterToken,
} from "@modules/money/di_tokens";
import type MoneyFormatterInterface from "@modules/money/Formatters/MoneyFormatter/MoneyFormatterInterface";
import type MoneyExchangerInterface from "@modules/money/MoneyExchanger/MoneyExchangerInterface";
import { Observable, map, switchMap } from "rxjs";
import { inject, singleton } from "tsyringe";

import { rewardsMoneyExchangerToken } from "../tokens";

@singleton()
class RewardsCurrencyFormatter {
    constructor(
        @inject(rewardsMoneyExchangerToken)
        private readonly rewardsMoneyExchanger: MoneyExchangerInterface,
        @inject(currencyProviderToken)
        private readonly currencyProvider: CurrencyProviderInterface,
        @inject(moneyFormatterToken)
        private readonly moneyFormatter: MoneyFormatterInterface
    ) {}

    private exchange(amount: number): Observable<number> {
        return this.currencyProvider
            .selectCurrency()
            .pipe(
                switchMap((selectedCurrency) =>
                    this.rewardsMoneyExchanger.exchange(
                        amount,
                        selectedCurrency
                    )
                )
            );
    }

    public selectFormattedCurrency(amount: number): Observable<string> {
        return this.exchange(amount).pipe(
            map((amount) => this.moneyFormatter.format(amount))
        );
    }
}

export default RewardsCurrencyFormatter;
